<template>
    <!-- ملخص عام مختصر قابل للطي (طلب مهندس الوزارة 2026-10-05):
         يُقرأ بنظرة، ومن لا يحتاجه يطويه فيبقى مطوياً في زياراته التالية. -->
    <div class="card mb-3 collapsible-summary">
        <div class="card-header d-flex align-items-center justify-content-between py-2 collapsible-summary__head"
             role="button" tabindex="0"
             @click="toggle" @keyup.enter="toggle">
            <div class="d-flex align-items-center gap-2">
                <i class="ti" :class="open ? 'ti-chevron-down' : 'ti-chevron-left'"></i>
                <span class="fw-semibold">{{ title }}</span>
            </div>
            <small class="text-muted" v-if="!open && collapsedHint">{{ collapsedHint }}</small>
        </div>
        <div class="card-body pt-3 pb-0" v-show="open">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CollapsibleSummary',
    props: {
        title: { type: String, default: 'ملخص' },
        /** مفتاح حفظ حالة الطيّ لكل شاشة — راحة للمستخدم فقط، ولا شيء يعتمد عليها. */
        storageKey: { type: String, default: '' },
        /** سطر قصير يظهر بجانب العنوان وهو مطوي. */
        collapsedHint: { type: String, default: '' },
    },
    data() {
        return { open: this.readState() };
    },
    methods: {
        readState() {
            if (!this.storageKey) return true;
            try {
                return localStorage.getItem('summary-open:' + this.storageKey) !== '0';
            } catch (e) {
                return true;
            }
        },
        toggle() {
            this.open = !this.open;
            if (!this.storageKey) return;
            try {
                localStorage.setItem('summary-open:' + this.storageKey, this.open ? '1' : '0');
            } catch (e) { /* التخزين غير متاح — الطيّ يعمل في هذه الزيارة فقط */ }
        },
    },
};
</script>

<style scoped>
.collapsible-summary__head {
    cursor: pointer;
    user-select: none;
}
</style>
